import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerSystemService } from '../../../services/customer-system/customer-system.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-system',
  templateUrl: './customer-system.component.html',
  styleUrls: ['./customer-system.component.css'],
  providers: []
})
export class CustomerSystemComponent implements OnInit {

  newDataAvailable = false;

  paginationType = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  stateFilterOptions: Array<{label: string, value: string | null}> = [];

  constructor(
    public srvCustomerSystem: CustomerSystemService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
    this.stateFilterOptions = [
      {label: '', value: null},
      {label: this.translate.instant('status.active'), value: '0'},
      {label: this.translate.instant('status.inactive'), value: '1'}
    ];
    this.translate.get(['status.active', 'status.inactive']).subscribe(t => {
      this.stateFilterOptions[1].label = t['status.active'];
      this.stateFilterOptions[2].label = t['status.inactive'];
    });
  }

  ngOnInit() {
  }

  refresh() {
    this.newDataAvailable = true;
  }

  showAddOrEditDialog(data): void {
    if (data == null) {
      this.srvCustomerSystem.itemEditing = null;
      this.router.navigate(['/customers/form']);
    } else {
      this.srvCustomerSystem.itemEditing = data;
      this.router.navigate(['/customers/form', data.id]);
    }
  }

  deleteItem(record): void {
    this.srvCustomerSystem.delete(record).subscribe(() => {
      this.refresh();
    });
  }

  recoverItem(record): void {
    this.srvCustomerSystem.recover(record).subscribe(() => {
      this.refresh();
    });
  }

  confirmDelete(record): void {
    this.translate.get(['kontable.delete', 'kontable.removeConfirmation']).subscribe(translations => {
      this.confirmationService.confirm({
        header: `${translations['kontable.delete']}!`,
        message: translations['kontable.removeConfirmation'],
        accept: () => this.deleteItem(record)
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/customer-system/customer-system.component.ts